import { render } from "./DisputeDetailComponent.vue?vue&type=template&id=5ab2a0c6&scoped=true"
import script from "./DisputeDetailComponent.vue?vue&type=script&lang=js"
export * from "./DisputeDetailComponent.vue?vue&type=script&lang=js"

import "./DisputeDetailComponent.vue?vue&type=style&index=0&id=5ab2a0c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab2a0c6"]])

export default __exports__